<template>
  <div class="global-content-box global-content-flex">
    <div class="displayItem" style="margin-bottom: 24px">
      <y-menu-title title="行为等级规则" class="title" />
      <!-- 启用状态 -->
      <div class="displayItem">
        <y-button type="blueLine" @click="toPage('swicth')">
          <img
            src="@/assets/images/memberAll/change.svg"
            alt
            style="
              width: 16px;
              height: 16px;
              margin-right: 8px;
              vertical-align: middle;
            "
          />切换等级规则方案
        </y-button>
      </div>
    </div>
    <div class="global-felx">
      <!-- 提示语 -->
      <y-tip>
        <div class="tipsCont">
          1.会员有效期，若不符合升级、保级、降级规则（或对应规则已关闭），会员将不会被降级，如需降级则需开启降级规则。
        </div>
        <div class="tipsCont">
          2.若开启了升级条件，则每个级别至少设置一个有效的升级规则。
        </div>
        <div class="tipsCont">
          3.降级功能开启后，若会员符合降级条件规则，则将被降级到指定等级。
        </div>
        <div class="tipsCont">
          4.若会员同时满足保级和降级规则，则优先保级规则。
        </div>
        <div class="tipsCont">
          5.等级规则修改后，会在第二天凌晨重新计算，会员如果满足新的规则能升级的会升级，但是不会降级。
        </div>
        <div class="tipsCont">
          6.所有与订单有关的指标，都是按订单的 “下单时间” 进行统计。
        </div>
        <div class="tipsCont">
          7.当会员退会后，若设置了对应的退会清零指标，则对这部分的会员需做降级处理。
        </div>
        <div class="tipsCont">
          8.所有与订单有关的指标，都是按订单的 “下单时间” 进行统计。
        </div>
        <div class="tipsCont">
          9.每个规则每个自然年可修改3次，请确认无误后再保存。
        </div>
      </y-tip>
      <div class="tabs">
        <el-tabs v-model="activeName">
          <el-tab-pane label="升级规则设置" name="1"> </el-tab-pane>
          <el-tab-pane label="保级规则设置" name="2"> </el-tab-pane>
          <el-tab-pane label="降级规则设置" name="3"> </el-tab-pane>
          <el-tab-pane label="退款时等级计算规则" name="4"> </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 升级规则设置：独立组件（用 v-show 保证切 tab 后仍能拿到 ref 做统一校验） -->
      <upgrade-rules
        v-show="activeName === '1'"
        ref="upgradeRulesRef"
        :up-rule-type="upRuleType"
      />
      <!-- 保级规则设置：独立组件 -->
      <relegation-rules
        v-show="activeName === '2'"
        ref="relegationRulesRef"
        :up-rule-type="upRuleType"
      />
      <!-- 降级规则设置：独立组件 -->
      <downgrade-rules
        v-show="activeName === '3'"
        ref="downgradeRulesRef"
        :up-rule-type="upRuleType"
      />
      <!-- 退款时等级计算规则设置：独立组件 -->
      <refund-rules
        v-show="activeName === '4'"
        ref="refundRulesRef"
        v-model="gradeRuleParams.refundRuleType"
      />
    </div>
    <!-- 保存：四个 tab 共用 -->
    <div class="global-bottom-btn">
      <y-button type="blue" v-if="loading" :loading="loading">保存</y-button>
      <y-button type="blue" v-else :loading="loading" @click="save">
        保存
      </y-button>
    </div>
  </div>
</template>

<script>
import { upRuleSwitch, getDetail, ruleSave } from "@/api/manage/scoreList";
import { updateMemberGradeRule } from "@/api/memberMessageSystem";
import relegationRules from "./relegation_rules.vue";
import upgradeRules from "./upgrade_rules.vue";
import downgradeRules from "./downgrade_rules.vue";
import refundRules from "./refund_rules.vue";

export default {
  components: {
    relegationRules,
    upgradeRules,
    downgradeRules,
    refundRules,
  },
  props: {
    upRuleType: {
      default: "",
    },
  },
  data() {
    return {
      isStart: false, //是否启用规则
      _upRuleType: "",
      form: {
        orderValidDate: "",
        behaviorLevelCalcRule: 0,
        gradeDetailList: [],
        // 等级有效期：1 永久有效、2 数值+单位后失效、3 数值年后的指定时间失效
        gradeValidDate: 1,
        gradeValidNum: "", // 方式2的数值：1-999 的正整数
        gradeValidUnit: "year", // year / month / day
        gradeValidYearNum: "", // 方式3的数值：1-999 的正整数
        gradeValidMonth: "", // 方式3的月份
        gradeValidDay: "", // 方式3的日期
      },
      // 方式3：月 / 日 下拉选项（日期部分见 computed.dayOptions，随月份变化）
      monthOptions: Array.from({ length: 12 }, (v, i) => i + 1),
      // radio: "1",
      gradeList: [
        // 会员等级设置
        { gradeCode: 1, gradeName: "店铺客户" },
      ],
      loading: false,
      goodsState: false, // 选择商品弹窗
      goodsPostForm: [], // 已选商品数据---弹窗用
      selectGoodsList: [], // 已选商品列表--指定商品
      selectGoodsList2: [], // 已选商品列表--排除特定商品
      selectGoodsType: 1, // 用于储存当前打开的弹窗类型，因公用一个组件，以此区分
      selectGoodsIndex: 1, // 用于储存当前选择商品的下标
      // 新建升级规则弹窗
      upgradeRulesVisible: false,
      upgradeRuleRow: {},
      upgradeRuleIndex: null, // null 新建，数字为编辑下标
      upgradeRuleData: null, // 编辑时回显的规则

      tableInfo: [
        {
          label: "等级名称",
          prop: "gradeName",
          slot: "gradeName",
          align: "center",
          width: "400px",
        },
        {
          label: "升级规则",
          align: "center",
          prop: "gradeName",
          slot: "gradeRule",
        },
      ],
      activeName: "1",
      removeVisible: false, // 移除黑名单弹窗
      removeRow: {}, // 移除黑名单弹窗数据
      removeIndex: 0, // 移除黑名单弹窗下标
      gradeRuleList: [], // 升级规则列表：每个等级的规则列表
      gradeRuleParams: {
        refundRuleType: 0,
      }, 
    };
  },
  created() {
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
  },
  mounted() {
    this.getDetail();
    //判断开启状态
    console.log("this.upRuleType", this.upRuleType);
    this._upRuleType = this.upRuleType;
    if (this._upRuleType == 1) {
      this.isStart = true;
    }
  },
  computed: {
    // 方式3的日期选项：2 月只有 1-28，其余月份 1-31
    dayOptions() {
      const max = Number(this.form.gradeValidMonth) === 2 ? 28 : 31;
      return Array.from({ length: max }, (v, i) => i + 1);
    },
    upgradeRulesTitle() {
      return this.activeName === "1" ? "升级规则" : "保级规则";
    },
  },
  methods: {
    //查询会员卡行为等级规则详情
    getDetail() {
      getDetail({ cardId: this.MemberSystemInfo.scoresCardId }).then((res) => {
        const data = res.data || {};
        // 顶部字段（等级规则、数据有效范围等）
        this.form = data;
        this.changeBehaviorLevelCalcRule(data.behaviorLevelCalcRule);
        // 详情只请求一次，把数据按 tab 拆分后分发给子组件回显
        this.$nextTick(() => {
          this.initChildDetail(data);
        });
      });
    },
    // 把详情数据拆成三个 tab 各自需要的形式，再分发给子组件
    initChildDetail(detail) {
      if (!detail) return;
      const grades = detail.gradeDetailList || [];
      // 下标 0 是最低等级（不参与规则），公共配置统一取下标 1 的数据
      const first = grades[0] || {};
      // 退款时等级计算规则：后端按等级存，取同一份即可
      this.gradeRuleParams.refundRuleType = first.refundRuleType || 0;

      const upgrade = this.$refs.upgradeRulesRef;
      if (upgrade && upgrade.initDetail) {
        upgrade.initDetail({
          upIsOpen: first.upIsOpen,
          upOrderValidDate: first.upOrderValidDate,
          behaviorLevelCalcRule: detail.behaviorLevelCalcRule,
          ...this.buildTimeForm(first, "upTime"),
          gradeDetailList: grades.map((item) => this.buildGradeItem(item, "up")),
        });
      }

      const relegation = this.$refs.relegationRulesRef;
      if (relegation && relegation.initDetail) {
        relegation.initDetail({
          reIsOpen: first.reIsOpen,
          reUnmatchType: first.reUnmatchType,
          reOrderValidDate: first.reOrderValidDate,
          behaviorLevelCalcRule: detail.behaviorLevelCalcRule,
          ...this.buildTimeForm(first, "reTime"),
          gradeDetailList: grades.map((item) => this.buildGradeItem(item, "re")),
        });
      }

      const downgrade = this.$refs.downgradeRulesRef;
      if (downgrade && downgrade.initDetail) {
        downgrade.initDetail({
          downIsOpen: first.downIsOpen,
          downType: first.downType,
          ...this.buildTimeForm(first, "downTime"),
          gradeDetailList: grades.map((item) => this.buildGradeItem(item, "down")),
        });
      }
    },
    // 每个等级的表格行：把接口的 xxxRuleList 转成表格/弹窗用的 upgradeRules
    buildGradeItem(item, prefix) {
      const ruleListKey = prefix === "up" ? "upgradeRuleList" : prefix === "re" ? "regradeRuleList" : "";
      return Object.assign({}, item, {
        upgradeRules: ruleListKey ? this.toUiRules(item[ruleListKey]) : [],
        specificItems: this.toUiGoods(item, prefix),
        excludeItems: [],
      });
    },
    // 接口的商品结构 → 商品选择弹窗（select-goods）需要的结构
    toUiGoodsItems(items) {
      return (items || []).map((goods) => ({
        itemTitle: goods.itemName,
        picUrl: goods.itemImage,
        price: goods.itemPrice,
        numIid: goods.itemSkuId,
        channelSellerManageId: goods.channelSellerManageId,
        platform: goods.platform,
      }));
    },
    // 规则条件里的商品列表 → 选择商品组件需要的结构
    toUiGoods(item, prefix) {
      const ruleListKey = prefix === "up" ? "upgradeRuleList" : prefix === "re" ? "regradeRuleList" : "";
      const rule = ruleListKey ? (item[ruleListKey] || [])[0] : null;
      return this.toUiGoodsItems(rule && rule.items);
    },
    // 后端等级有效期字段 → 前端表单字段（xxxTimeType：3 永久、4 数值+单位、2 年月日）
    buildTimeForm(grade, prefix) {
      const typeKey = `${prefix}Type`;
      // downTimeType 对应的是 downTimeType，reTime 对应 reTimeType，upTime 对应 upTimeType
      const timeType = grade[typeKey] || 3;
      const form = { [typeKey]: timeType };
      const timeYear = grade[`${prefix}Year`];
      const timeMonth = grade[`${prefix}Month`];
      const timeDay = grade[`${prefix}Day`];
      const afterDay = grade[`${prefix}AfterDay`];
      if (timeType == 4) {
        // 数值 + 单位：新数据只落其中一个字段，取第一个非空的
        if (timeYear !== null && timeYear !== undefined) {
          form.gradeValidNum = timeYear;
          form.gradeValidUnit = "year";
        } else if (timeMonth !== null && timeMonth !== undefined) {
          form.gradeValidNum = timeMonth;
          form.gradeValidUnit = "month";
        } else if (timeDay !== null && timeDay !== undefined) {
          form.gradeValidNum = timeDay;
          form.gradeValidUnit = "day";
        } else if (afterDay !== null && afterDay !== undefined) {
          // 旧数据兜底：按天
          form.gradeValidNum = afterDay;
          form.gradeValidUnit = "day";
        }
      } else if (timeType == 2) {
        // N 年后的 M 月 D 日
        form.gradeValidYearNum =
          timeYear === null || timeYear === undefined ? "" : timeYear;
        form.gradeValidMonth =
          timeMonth === null || timeMonth === undefined ? "" : timeMonth;
        form.gradeValidDay =
          timeDay === null || timeDay === undefined ? "" : timeDay;
      }
      return form;
    },
    // 接口规则（扁平条件）→ 规则弹窗的 { conditions: [] }
    toUiRules(list) {
      return (list || []).map((rule) => ({
        // 保留接口的规则id，保存时回传给 scoresMemberGradeRuleId
        id: rule.id,
        conditions: this.toUiConditions(rule),
      }));
    },
    toUiConditions(rule) {
      if (!rule) return [];
      // 与规则弹窗（upgradeRulesDialog）保存的字段保持一致：
      // op 用后端操作符（>、>=、include；商品用 "1"/"2"），组件里的 formatRule 也按这套解析
      const conditions = [];
      if (rule.minMoney !== null && rule.minMoney !== undefined) {
        conditions.push({
          key: "totalAmount",
          type: "amount",
          op: ">",
          value: rule.minMoney,
          label: "累计交易金额（实付）",
        });
      }
      if (rule.minCount !== null && rule.minCount !== undefined) {
        conditions.push({
          key: "totalCount",
          type: "count",
          op: ">",
          value: rule.minCount,
          label: "累计交易次数",
        });
      }
      if (rule.itemSelectType == 1 || rule.itemSelectType == 2) {
        conditions.push({
          // key 要和左侧「购买过商品」指标的 key 一致，否则弹窗里该指标不会被置灰
          key: "buyGoods",
          type: "goods",
          // 组件里判断 cond.op === "1" 为「包含」，"2" 为「不包含」
          op: String(rule.itemSelectType),
          // 接口结构 → 商品选择弹窗需要的结构
          items: this.toUiGoodsItems(rule.items),
          label: "购买过商品",
        });
      }
      const pointMap = [
        { key: "totalPoint", valueKey: "totalScore", opKey: "totalScoreOper", label: "累计获取积分" },
        { key: "validPoint", valueKey: "remainScore", opKey: "remainScoreOper", label: "当前有效积分" },
        { key: "consumePoint", valueKey: "costScore", opKey: "costScoreOper", label: "累计消费积分" },
      ];
      pointMap.forEach((item) => {
        const value = rule[item.valueKey];
        if (value !== null && value !== undefined) {
          conditions.push({
            key: item.key,
            type: "point",
            op: rule[item.opKey] || ">",
            value: value,
            label: item.label,
          });
        }
      });
      // 等级条件：curGrades 为空表示未配置，不生成条件，避免出现「当前等级属于会员卡」这样的空文案
      if (
        rule.curGradesOper &&
        rule.curGrades !== null &&
        rule.curGrades !== undefined &&
        String(rule.curGrades).trim() !== ""
      ) {
        conditions.push({
          key: "currentLevel",
          type: "level",
          op: rule.curGradesOper,
          // 会员卡下拉的可选值（当前体系只有一张卡，value 为 card）
          cardValue: "card",
          levelValue: Number(rule.curGrades),
          label: "当前等级",
        });
      }
      return conditions;
    },
    // 保存：先校验三个 tab，再把各自的 form 合并成 gradeRuleList（长度 = 等级数组长度）
    save() {
      const upgrade = this.$refs.upgradeRulesRef;
      const relegation = this.$refs.relegationRulesRef;
      const downgrade = this.$refs.downgradeRulesRef;
      const children = [upgrade, relegation, downgrade];
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (!child) {
          this.$message.warning("页面还未加载完成，请稍后重试");
          return;
        }
        // 子组件校验不通过会自己弹出提示，这里直接中断
        if (!child.validate()) return;
      }
      // 三个 tab 各自返回组装好的 form 数据
      const upgradeForm = upgrade.save();
      const relegationForm = relegation.save();
      const downgradeForm = downgrade.save();
      // 按等级下标合并：每个等级分别取三个 tab 的配置
      const gradeRuleList = this.mergeGradeRuleList([
        upgradeForm,
        relegationForm,
        downgradeForm,
      ]);
      console.log("gradeRuleList", gradeRuleList);
      const params = {
        gradeRuleList,
        scoresCardId: this.$store.state.MemberSystemInfo.scoresCardId,
      };
      console.log("params", params);
      updateMemberGradeRule(params).then((res) => {
        if (res.code == 200) {
          this.$message.success("保存成功");
          // 保存成功后重新拉取详情，保证回显与后端一致
          this.getDetail();
        } else {
          this.$message.error(res.msg || "保存失败");
        }
      });
    },
    // 合并三个 tab 的规则：数组长度取等级数组的长度
    mergeGradeRuleList(forms) {
      // type：1 升级、2 保级、3 降级
      const upgradeList = this.saveUpgradeRule(forms[0], 1);
      const relegationList = this.saveUpgradeRule(forms[1], 2);
      const downgradeList = this.saveUpgradeRule(forms[2], 3);
      const length = Math.max(
        upgradeList.length,
        relegationList.length,
        downgradeList.length
      );
      const gradeRuleList = [];
      for (let i = 0; i < length; i++) {
        // 同名 key（gradeName、scoresMemberGradeId）以先出现的为准
        gradeRuleList.push(
          Object.assign(
            {
              // 退款时等级计算规则：属于整张会员卡的配置，每个等级都要带上
              refundRuleType: this.gradeRuleParams.refundRuleType || 0,
            },
            upgradeList[i] || {},
            relegationList[i] || {},
            downgradeList[i] || {}
          )
        );
      }
      return gradeRuleList;
    },
    // 切换模块
    toPage(name) {
      this.$emit("toPage", name);
    },
    //改变启用状态
    isChangeSwitch() {
      let newType = this.isStart;
      this.isStart = false;
      console.log(" this.upRuleType1", this._upRuleType);
      if (this._upRuleType == 2) {
        this.isStart = false;
        this.$message.warning("启用失败: 启用行为等级规则需关闭成长值等级规则");
      } else {
        let params = {
          cardId: this.$store.state.MemberSystemInfo.scoresCardId,
          upRuleType: 1,
          state: newType,
        };
        upRuleSwitch(params)
          .then((res) => {
            if (res.code == 200) {
              console.log("newType", newType);
              if (newType) {
                this.isStart = true;
                this._upRuleType = 1;
                this.$message.warning("启用成功");
              } else {
                this.isStart = false;
                this.$message.warning("修改成功");
                this._upRuleType = "";
              }
              this.$emit("changeUpRuleType", this._upRuleType);
            } else {
              this.isStart = false;
            }
          })
          .catch((err) => {
            this.isStart = false;
          });
      }
    },
    // 升级规则保存：新建追加、编辑覆盖
    // type：1 升级、2 保级、3 降级；返回与等级数组等长的规则数组
    saveUpgradeRule(form, type) {
      if (!form || !form.gradeDetailList) return [];
      return form.gradeDetailList.map((item) => {
        let obj = {};
        obj.gradeName = item.gradeName;
        obj.scoresMemberGradeId = item.scoresMemberGradeId;
        if (type == 1) {
          obj.upIsOpen = form.upIsOpen;
          obj.upTimeType = form.upTimeType;
          Object.assign(obj, this.buildTimePayload(form, "upTimeType", "upTime"));
          obj.upOrderValidDate = form.upOrderValidDate;
          obj.upgradeRuleList = this.buildRuleConditions(item.upgradeRules, {
            scoresCardId: this.MemberSystemInfo.scoresCardId,
            scoresMemberGradeId: item.scoresMemberGradeId,
            gradeType: 1,
          });
        }
        if (type == 2) {
          obj.reIsOpen = form.reIsOpen;
          obj.reTimeType = form.reTimeType;
          obj.reUnmatchType = form.reUnmatchType;
          Object.assign(obj, this.buildTimePayload(form, "reTimeType", "reTime"));
          obj.reOrderValidDate = form.reOrderValidDate;
          obj.regradeRuleList = this.buildRuleConditions(item.upgradeRules, {
            scoresCardId: this.MemberSystemInfo.scoresCardId,
            scoresMemberGradeId: item.scoresMemberGradeId,
            gradeType: 2,
          });
        }
        if (type == 3) {
          obj.downIsOpen = form.downIsOpen;
          obj.downTimeType = form.downTimeType;
          Object.assign(obj, this.buildTimePayload(form, "downTimeType", "downTime"));
          // 到期降级的目标等级（降级 tab 里每个等级单独选择）
          obj.downToLevel = item.downToLevel || form.downToLevel;
        }
        return obj;
      });
    },
    // 等级有效期 → 接口字段
    // 三种类型：3 永久、4 数值+单位、2 年月日
    // 每次都把三个字段先置 null，避免旧值残留导致回显时选错单位
    buildTimePayload(form, typeKey, prefix) {
      const toNum = (val) =>
        val === "" || val === null || val === undefined ? null : Number(val);
      const payload = {
        [`${prefix}Year`]: null,
        [`${prefix}Month`]: null,
        [`${prefix}Day`]: null,
      };
      const timeType = form[typeKey];
      if (timeType == 4) {
        const num = toNum(form.gradeValidNum);
        if (form.gradeValidUnit === "year") {
          payload[`${prefix}Year`] = num;
        } else if (form.gradeValidUnit === "month") {
          payload[`${prefix}Month`] = num;
        } else {
          payload[`${prefix}Day`] = num;
        }
      } else if (timeType == 2) {
        payload[`${prefix}Year`] = toNum(form.gradeValidYearNum);
        payload[`${prefix}Month`] = toNum(form.gradeValidMonth);
        payload[`${prefix}Day`] = toNum(form.gradeValidDay);
      }
      return payload;
    },
    // 规则条件 → 接口字段：条件可能存在缺失，这里统一做空值兜底
    // ctx：{ scoresCardId, scoresMemberGradeId, gradeType }，用于把商品转成接口结构
    buildRuleConditions(rules, ctx) {
      const context = ctx || {};
      return (rules || []).map((rule) => {
        const conditions = (rule && rule.conditions) || [];
        const findCond = (key) => conditions.find((cond) => cond.key === key);
        const amount = findCond("totalAmount");
        const count = findCond("totalCount");
        // 商品条件的 key 在规则弹窗里是 goods，历史数据里可能是 buyGoods
        const goods = findCond("buyGoods") || findCond("goods");
        const totalPoint = findCond("totalPoint");
        const validPoint = findCond("validPoint");
        const consumePoint = findCond("consumePoint");
        const level = findCond("currentLevel");
        return {
          // 编辑已有规则时带上原规则id，新增时不传
          id: rule && rule.id ? rule.id : undefined,
          minMoney: amount ? amount.value : undefined,
          minCount: count ? count.value : undefined,
          items: goods ? this.toApiGoodsItems(goods.items, context, rule) : [],
          // 弹窗里商品 op 是 "1"/"2"，接口要数字
          itemSelectType: goods ? Number(goods.op) : undefined,
          totalScore: totalPoint ? totalPoint.value : undefined,
          totalScoreOper: totalPoint ? totalPoint.op : undefined,
          remainScore: validPoint ? validPoint.value : undefined,
          remainScoreOper: validPoint ? validPoint.op : undefined,
          costScore: consumePoint ? consumePoint.value : undefined,
          costScoreOper: consumePoint ? consumePoint.op : undefined,
          // 等级条件存的是 levelValue
          curGrades: level ? level.levelValue : undefined,
          curGradesOper: level ? level.op : undefined,
        };
      });
    },
    // 商品选择弹窗的数据 → 接口需要的 items 结构（否则商品弹窗回显会有问题）
    toApiGoodsItems(items, ctx, rule) {
      return (items || []).map((goods) => ({
        channelSellerManageId: goods.channelSellerManageId,
        scoresCardId: ctx.scoresCardId,
        scoresMemberGradeId: ctx.scoresMemberGradeId,
        scoresMemberGradeRuleId: rule && rule.id ? rule.id : undefined,
        itemName: goods.itemTitle,
        itemImage: goods.picUrl,
        itemPrice: goods.price,
        itemSkuId: goods.numIid,
        type: 1,
        gradeType: ctx.gradeType,
      }));
    },
    changeBehaviorLevelCalcRule(val) {
      if (val == 0) {
        const index = this.tableInfo.findIndex((item) => item.prop == "trade");
        if (index != -1) {
          this.tableInfo.splice(index, 1);
        }
      } else if (val == 2) {
        this.tableInfo.push({
          label: "交易笔数",
          prop: "trade",
          slot: "trade",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input__prefix {
  left: 3px !important;
}
.displayItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.title {
  margin-bottom: 0px;
  margin-right: 24px;
}
// 升级规则列：多条规则纵向排列，底部是新建入口
.rule-list {
  width: 100%;
}

.rule-line {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border-bottom: 1px solid #ebeef5;
  &:last-child {
    border-bottom: none;
  }
}

.rule-text {
  flex: 1;
  margin-right: 16px;
  text-align: center;
  font-size: 13px;
  color: #606266;
  word-break: break-all;
}

.rule-opt {
  flex-shrink: 0;
  font-size: 13px;
  color: $theme-color;
  cursor: pointer;

  & + & {
    margin-left: 16px;
  }
}

.rule-add {
  padding: 8px 0;
  text-align: center;
}

.tableCont {
  width: 100%;
  text-align: center;
  padding: 0px 10px;
  // margin: 0 5%;
  .select_btn {
    color: $theme-color;
    // margin: 0 10px;
    margin-left: 12px;
    cursor: pointer;

    span {
      margin: 0 5px;
    }
  }
}

.inline_input {
  width: 100px;
  margin: 0 8px;
}
.tabs {
  margin-top: 20px;
}
:deep(.el-table td .cell) {
  padding: 0px !important;
}
// 移除黑名单弹窗正文：居中展示提示文案
.remove-tip {
  max-width: 620px;
  margin: 0 auto;
  padding: 32px;
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  color: #333333;
}
// 等级有效期：单选项与内嵌输入框同一行排列
// 注意：element-ui 的 .el-radio-group 自带 font-size: 0，这里必须显式恢复字号，
// 否则组内平铺的「后失效 / 年后的 / 失效」等文字会因字号为 0 而不可见
.valid-date {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 22px;

  .el-radio {
    margin-right: 12px;
  }
  .valid-inline {
    display: inline-flex;
    align-items: center;
    margin-right: 20px;
  }
  .valid-num {
    width: 110px;
  }
  .valid-unit {
    width: 90px;
    margin-left: 8px;
  }
  // 前面已有文字时（如「年后的 [月] 月」），间距交给文字自身的 margin，避免叠加
  .valid-text + .valid-unit {
    margin-left: 0;
  }
  .valid-text {
    margin: 0 8px;
    color: #606266;
  }
}
// 保级不成功设置：第一个选项下的红色补充说明
.radio-tip {
  display: block;
  line-height: 22px;
  padding-left: 14px;
  color: red;
}
.grade-upgrade-rule {
  display: flex;
  padding-top: 10px;
}
</style>